import { render, staticRenderFns } from "./allHistory.vue?vue&type=template&id=c5261006&scoped=true"
import script from "./allHistory.vue?vue&type=script&lang=js"
export * from "./allHistory.vue?vue&type=script&lang=js"
import style0 from "./allHistory.vue?vue&type=style&index=0&id=c5261006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5261006",
  null
  
)

export default component.exports